<template>
    <div>
        <report-header
            :title="title"
            :isShowDateRange="true"
            :formatDateRangeTitle="dateRange"
        />
        <b-card>
            <div class="mb-4">
                <h4>
                    <span id="top">Summary</span>
                </h4>
                <hr />
                <div v-if="!loaded">
                    <img src="/apps/assets/img/ajax-loader.gif" class="p-3" />
                </div>
                <div id="report-body" v-if="loaded" class="w-100">
                    <div
                        v-if="summary && Object.keys(summary).length > 0"
                        class="w-100"
                    >
                        <b-table-simple bordered>
                            <b-thead head-variant="dark">
                                <tr>
                                    <th width="30%">
                                        Appointment Type
                                    </th>
                                    <th width="10%" style="text-align: center;">
                                        Appointments
                                    </th>
                                    <th width="10%" style="text-align: center;">
                                        Patients
                                    </th>
                                    <th width="10%" style="text-align: center;">
                                        Sales
                                    </th>
                                    <th width="10%" style="text-align: center;">
                                        Tax
                                    </th>
                                    <th width="10%" style="text-align: center;">
                                        Total Sales
                                    </th>
                                    <th width="10%" style="text-align: center;">
                                        Returns
                                    </th>
                                    <th width="10%" style="text-align: center;">
                                        Net Sales
                                    </th>
                                </tr>
                            </b-thead>
                            <tbody>
                                <tr v-for="(item, i) in summary" :key="i">
                                    <td>
                                        <a
                                            href="#"
                                            v-scroll-to="
                                                `#type_${summaryNumber}`
                                            "
                                        >
                                            {{ item.type }}
                                        </a>
                                    </td>
                                    <td style="text-align: center;">
                                        {{ item.appointment }}
                                    </td>
                                    <td style="text-align: center;">
                                        {{ item.patient }}
                                    </td>
                                    <td style="text-align: center;">
                                        {{ _toCurrency(item.sales) }}
                                    </td>
                                    <td style="text-align: center;">
                                        {{ _toCurrency(item.tax) }}
                                    </td>
                                    <td style="text-align: center;">
                                        {{ _toCurrency(item.total_sales) }}
                                    </td>
                                    <td style="text-align: center;">
                                        {{ _toCurrency(item.return_amount) }}
                                    </td>
                                    <td style="text-align: center;">
                                        {{
                                            _toCurrency(
                                                item.total_sales -
                                                    item.return_amount
                                            )
                                        }}
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td>
                                        <b>Total</b>
                                    </td>
                                    <td style="text-align: center;">
                                        <b>{{ total.appointment }}</b>
                                    </td>
                                    <td style="text-align: center;">
                                        <b>{{ total.patient }}</b>
                                    </td>
                                    <td style="text-align: center;">
                                        <b>{{ _toCurrency(total.sales) }}</b>
                                    </td>
                                    <td style="text-align: center;">
                                        <b>{{ _toCurrency(total.tax) }}</b>
                                    </td>
                                    <td style="text-align: center;">
                                        <b>{{
                                            _toCurrency(total.total_sales)
                                        }}</b>
                                    </td>
                                    <td style="text-align: center;">
                                        <b>{{
                                            _toCurrency(total.return_amount)
                                        }}</b>
                                    </td>
                                    <td style="text-align: center;">
                                        <b>{{
                                            _toCurrency(
                                                total.total_sales -
                                                    total.return_amount
                                            )
                                        }}</b>
                                    </td>
                                </tr>
                            </tfoot>
                        </b-table-simple>
                    </div>
                    <div v-else>
                        <i>No records available</i>
                    </div>
                </div>
            </div>
            <div v-if="Object.keys(detail).length > 0">
                <div v-for="(item, i) in detail" :key="i">
                    <h4 v-bind:id="`type_${detailNumber}`">
                        <span>{{ item[0].appointment_type }}</span>
                    </h4>
                    <b-table-simple bordered>
                        <b-thead head-variant="dark">
                            <tr>
                                <th width="30%">
                                    Provider
                                </th>
                                <th width="10%" style="text-align: center;">
                                    Appointments
                                </th>
                                <th width="10%" style="text-align: center;">
                                    Patients
                                </th>
                                <th width="10%" style="text-align: center;">
                                    Sales
                                </th>
                                <th width="10%" style="text-align: center;">
                                    Tax
                                </th>
                                <th width="10%" style="text-align: center;">
                                    Total Sales
                                </th>
                                <th width="10%" style="text-align: center;">
                                    Returns
                                </th>
                                <th width="10%" style="text-align: center;">
                                    Net Sales
                                </th>
                            </tr>
                        </b-thead>

                        <tbody>
                            <tr v-for="(row, i) in item" :key="i">
                                <td>
                                    {{ row.provider }}
                                </td>
                                <td style="text-align: center;">
                                    {{ row.appointment }}
                                </td>
                                <td style="text-align: center;">
                                    {{ row.patient }}
                                </td>
                                <td style="text-align: center;">
                                    {{ _toCurrency(row.sales) }}
                                </td>
                                <td style="text-align: center;">
                                    {{ _toCurrency(row.tax) }}
                                </td>
                                <td style="text-align: center;">
                                    {{ _toCurrency(row.total_sales) }}
                                </td>
                                <td style="text-align: center;">
                                    {{ _toCurrency(row.return_amount) }}
                                </td>
                                <td style="text-align: center;">
                                    {{
                                        _toCurrency(
                                            row.total_sales - row.return_amount
                                        )
                                    }}
                                </td>
                            </tr>
                        </tbody>
                    </b-table-simple>
                </div>
            </div>
        </b-card>
    </div>
</template>
<script>
import ScheduleHelper from "@/module/schedule/helper";
import Report from "@/mixins/report.js";

export default {
    components: {
        ReportHeader: () => import("@/components/report/report-header")
    },
    mixins: [ScheduleHelper, Report],
    props: {
        data: {
            type: Object,
            default() {
                return {
                    start: this.getStartDate("month"),
                    end: this.getEndDate("day"),
                    datePickerOptions: {
                        format: this.getDateFormat()
                    }
                };
            }
        }
    },
    data() {
        return {
            locale: "en-US",
            loaded: false,
            summary: [],
            detail: [],
            title: "",
            meta: "",
            summaryTypeCount: 0,
            detailTypeCount: 0,
            dateRange: ""
        };
    },
    computed: {
        summaryNumber() {
            return this.summaryTypeCount + 1;
        },
        detailNumber() {
            return this.detailTypeCount + 1;
        }
    },
    mounted() {
        let self = this;
        self.data.isShowDateRange = true;
        self.data.start = self.getStartDate("month");
        self.data.end = self.getEndDate("day");
        self.data.from = self.converToUnix(self.data.start);
        self.data.to = self.converToUnix(self.data.end);
        self.data.datePickerOptions.format = this.getDateFormat();
        self.data.datePickerOptionDefault = 3;
        self.data.filterDateOption = true;

        self.init();
        self.$root.$on("report-filter-date-range:refresh", this.init);

        window.scrollTo(0, 0);
    },
    beforeDestroy: function () {
        this.$root.$off("report-filter-date-range:refresh", this.init);
    },
    methods: {
        async init(params) {
            let self = this;
            self.dateRange = self.getDateRange(self.data.from, self.data.to);

            await self.$http
                .get(
                    process.env.BARRAMUNDI +
                        "/report/reports/" +
                        self.$route.params.id,
                    {
                        params: {
                            from: params ? params.from : self.data.start.unix(),
                            to: params ? params.to : self.data.end.unix()
                        }
                    }
                )
                .then(function (response) {
                    let res = response.data;
                    self.code = response.status;
                    self.meta = res.response.resource.meta;
                    self.title = self.capitalize(self.meta.title);
                    self.summary = res.response.resource.summary;
                    self.detail = res.response.resource.detail;
                    self.total = res.response.resource.summary_total;
                    self.dynamicPageTitle(self.title);
                    self.dateRange = self.getDateRange(
                        self.meta.from,
                        self.meta.to
                    );

                    if (self.code === 200) {
                        self.loaded = true;
                    }
                });
        }
    }
};
</script>
